import React from 'react'
import _ from 'lodash/fp'

import { makeStyles, useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import { RETURN_PATH } from '../config'

import Grid from '@material-ui/core/Grid'
import Hidden from '@material-ui/core/Hidden'

import BottomBar from './BottomBar'

import { builder, BuilderComponent } from '@builder.io/react'

builder.init('32eea804311a4d17817f2e534ded7af8')

const useStyles = makeStyles(theme => ({
  container: {
    background: 'white',
    height: '100%',
    minHeight: '100vh'
  },
  routedContainer: {
    background: 'white',
    height: '100%',
    minHeight: '100vh',
    position: 'fixed',
    overflowY: 'auto',
    width: '100vw',
    [theme.breakpoints.up('md')]: {
      width: 'calc(100vw - 240px)'
    }
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
    paddingBottom: 64,
    paddingTop: 64,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    [theme.breakpoints.up('md')]: {
      justifyContent: 'flex-start'
    }
  }
}))

const useIsUp = key => {
  const theme = useTheme()
  return useMediaQuery(theme.breakpoints.up(key))
}

const ImageSide = _props => {
  return (
    <Hidden smDown>
      <Grid item xs={6}>
        <div style={{ position: 'sticky', top: 0 }}>
          <BuilderComponent model='split-screen-content' />
        </div>
      </Grid>
    </Hidden>
  )
}

const BottomIcon = _props => (
  <Hidden mdUp>
    <img style={{ width: 200, margin: '0 auto' }} src={`${RETURN_PATH}/static/media/glfr-logo-800.png`} />
  </Hidden>
)

const ContentSide = props => {
  const classes = useStyles()
  const noStickyBottomBar = useIsUp('md')
  const showBottomBar = !props.noBottomBar && !_.isEmpty(props.bottomBar)
  return (
    <Grid item xs={12} md={6}>
      <div className={classes.content}>
        {props.children}
        {(!props.noIcon) && <BottomIcon />}
        {showBottomBar && <BottomBar noSticky={noStickyBottomBar} {...props.bottomBar} />}
      </div>
    </Grid>
  )
}

const SplitContainer = props => {
  const classes = useStyles()
  return (
    <Grid
      container
      className={props.routed ? classes.routedContainer : classes.container}
    >
      <ImageSide />
      <ContentSide {...props} />
    </Grid>
  )
}

export default SplitContainer
